// extracted by mini-css-extract-plugin
export var addLinkSubtitle = "DynamicTextListField-module__addLinkSubtitle___c+n5l";
export var textFieldContainer = "DynamicTextListField-module__textFieldContainer___qbCso";